(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ContextController', ContextController);

    ContextController.$inject = ['$state', 'Context', 'Principal'];

    function ContextController($state, Context, Principal) {
        var vm = this;
        vm.save = save;
        vm.searchText = '';
        vm.viewSearch = false;
        vm.contexts = [];

        vm.loadAll = function() {
            Context.query(
                {search: vm.searchText}
            ).$promise.then(
                function (resp) {
                    if(resp.length == 1 && vm.searchText=='') {
                        var element = document.getElementById("oneContext");
                        element.href = "/jot/api/context/" + resp[0].id;
                        element.click();
                    } else {
                        vm.viewSearch = true;
                        vm.contexts = resp.map(function (ct) {
                            var name = ct.domainName.split(" ");
                            ct.logo = '';
                            for (var i = 0, len = name.length > 3 ? 3 : name.length; i < len; i++) {
                                ct.logo += name[i].charAt(0).toUpperCase();
                            }
                            return ct;
                        });
                    }
                });
        }

        vm.loadAll();

        function save(context) {

            Context.save(context, onSuccess, onError);

            function onSuccess() {
                Principal.identity(true).then(function (account) {
                    if(account.authorities.length == 1)
                        $state.go('performance');
                    else
                        $state.go('home'); //cambio stato solo dopo che la promise è stata risolta per evitare N chiamate parallele per la risoluzione degli state dell'app
                });
            }

            function onError(error) {

            }
        }

    }
})();
